import useComposeBookingProps from '../pages/BookingForm/hooks/useComposeBookingProps';
import useDraftBookingStepProps from '../pages/BookingForm/hooks/useDraftBookingStepProps';
import DraftBookingStepProps from '../pages/BookingForm/types/pageProps/DraftBookingStepProps';
import BookingParameters from '../types/BookingParameters';

type DraftBookingDetails = { bookingReference: string };
type ReturnType = DraftBookingDetails | BookingParameters | undefined;

const useBookingReferenceOrParameters = (): ReturnType => {
    /**
     * We pretend like we're in a draft booking step, but we might not be.
     */
    const { booking } =
        useDraftBookingStepProps() as Partial<DraftBookingStepProps>;

    const { parameters } = useComposeBookingProps();

    if (booking) {
        return {
            bookingReference: booking.reference,
        };
    }

    if (!parameters) {
        return undefined;
    }

    const { dock, boatModel, ...relevantParameters } = parameters;

    return relevantParameters;
};

export default useBookingReferenceOrParameters;
